import React, { useEffect, useState } from 'react';
import Piechart from "components/charts/PieChart";
import { HorizontalBarchart } from "components/charts/HorizontalBarchart";
import { useTestObjectRef, BI } from 'utils/testUtils';
import { useDispatch, useSelector, useStore } from "react-redux";
import { readcheckedfilterAllCompanyResultsByLawyerIds } from "state/actions/readCheckedActions";
import color from "../../utils/color";

const getLawyerCollegeCount = (currentCollegesResult, top) => {
    let colleges = currentCollegesResult.map(a => a.attbr);
    let occurrences = {};
    for (let i = 0, j = colleges.length; i < j; i++) {
        occurrences[colleges[i]] = (occurrences[colleges[i]] || 0) + 1;
    }
    let result = Object.entries(occurrences).map(([attbr, count]) => ({ college: attbr, count }));
    result.sort((a, b) => b.count - a.count);
    return result.slice(0, top);
}
const ReadCheckedCollegesBi = ({ isOverlay = false, closeDialog, currentCollegesResults, chartType }) => {
    const [stats, setStats] = useState([]);
    const dispatch = useDispatch();
    const store = useStore();
    const BiValue = isOverlay ? BI.READ_CHECKED_OVERLAY_COLLEGES_CHART : BI.READ_CHECKED_COLLEGES_CHART;
    const chartRef = useTestObjectRef(BiValue);
    useEffect(() => {
        async function getStats() {
            if (currentCollegesResults) {
                let top = 5;
                if (isOverlay) {
                    top = currentCollegesResults.length;
                }
                let result = getLawyerCollegeCount(currentCollegesResults, top);
                setStats(result);
            }
        }

        getStats();
    }, [currentCollegesResults]);
    const filterByLawyerIds = legendItem => {
        const result = store.getState().readchecked.readSelectedcurrentCollegesResults;
        if (result) {
            const lawyerIds = result.filter(item => item.attbr === legendItem.text).map(item => item.lId);
            dispatch(readcheckedfilterAllCompanyResultsByLawyerIds(lawyerIds));
            if(isOverlay){
                closeDialog();
            }
        }
    }

    return (
        <div
            id="readCheckedColleges"
        >

            {chartType === "Pie" && <Piechart
                label="Colleges"
                data={stats.map(item => item.count)}
                labels={stats.map(item => item.college)}
                ref={chartRef}
                legendCallBack={(event, legendItem) => filterByLawyerIds(legendItem)}
                backgroundColors={[...color(stats.length)]} />
            }
            {chartType === "Bar" && <HorizontalBarchart
                label="Colleges"
                data={stats.map(item => item.count)}
                labels={stats.map(item => item.college)}
                ref={chartRef}
                legendCallBack={(event, legendItem) => filterByLawyerIds(legendItem)}
                backgroundColors={[...color(stats.length)]} />
            }
        </div>
    );
};
export default ReadCheckedCollegesBi;
